import { useAdmin } from '@vtex/raccoon-next'
import { useAdminUser } from 'hooks'
import { catchLogger } from 'shared'

type Event = {
  event: string
  properties: Record<string, any>
}

const ANALYTICS_ENDPOINT = 'https://rc.vtex.com/api/analytics/schemaless-events'

const APP_NAME = 'admin-promotions'

export function useRedshiftPlugin() {
  const admin = useAdmin()
  const { account, production, locale } = admin

  const { data: user, isError } = useAdminUser()

  const enabled: boolean = production && !user?.internalUser

  function sendToRedshift(eventName: string, data?: any) {
    const body = {
      name: APP_NAME,
      eventName,
      data,
      meta: {
        account,
        userId: user?.id,
        timestamp: new Date().toJSON(),
        locale,
      },
    }

    catchLogger({
      id: 'redshift-analytics-fetch',
      admin,
      throwOnError: false,
      fn: () =>
        fetch(ANALYTICS_ENDPOINT, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(body),
        }).catch((error: unknown) => {
          if (typeof error === 'object' && error !== null) {
            Object.assign(error, { url: ANALYTICS_ENDPOINT })
          }

          throw error
        }),
    })
  }

  return {
    name: 'redshift-plugin',
    track: ({ payload }: { payload: Event }) => {
      if (!enabled || isError) return

      sendToRedshift(payload.event, payload.properties)
    },
  }
}
